import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom"; // 追加
import PageTitle from "../../components/PageTitle";
import { ILLUSTRATIONS } from "../gallery/Ilustrations"; // イラストデータの読み込み
import "./Top.css"; // 背景や文字色の統一スタイルを読み込み

import  { UpdateList }  from "../../components/updatelist";
import { SiBluesky } from 'react-icons/si';
import { CiCalendar } from 'react-icons/ci';

import { MdAccessTime } from "react-icons/md";

import { FaStar } from "react-icons/fa6";

import EventLists from "../../components/EventLists";	//イベントリスト

import { FaBookOpen } from "react-icons/fa";


// タグ（#オリジナル）にマッチするイラストを抽出し、ランダムに並び替える
const targetTags = ["original"];
const slideImages = ILLUSTRATIONS.filter(illust =>
	illust.tags.some((tag) => targetTags.includes(tag))
).sort(() => Math.random() - 0.5);


const Top = () => {
	const navigate = useNavigate(); // 追加
	const [currentIndex, setCurrentIndex] = useState(0);

	// 15秒ごとに画像を切り替える
	useEffect(() => {
		if (slideImages.length === 0) return;
		const interval = setInterval(() => {
			setCurrentIndex((prev) => (prev + 1) % slideImages.length);
		}, 15000);
		return () => clearInterval(interval);
	}, []);




	// BlueSkyのタイムラインを取得
	const [feed, setFeed] = useState<any[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const loadBlueskyFeed = async () => {
			try {
				const handle = 'adzuki0324.bsky.social';
 
				// プロフィール取得
				const profileRes = await fetch(
					`https://public.api.bsky.app/xrpc/app.bsky.actor.getProfile?actor=${handle}`
				);
				if (!profileRes.ok) throw new Error('Profile fetch failed');
				const profile = await profileRes.json();

				// 判定用のURI取得をより柔軟に（pinnedPostUri 以外もチェック）
				const pinnedUri = profile.pinnedPostUri || profile.pinnedPost || profile.pinned_uri;
				console.log('📌 取得した固定URI:', pinnedUri);
 
				// ========== フィード取得 ==========
				const feedRes = await fetch(
					`https://public.api.bsky.app/xrpc/app.bsky.feed.getAuthorFeed?actor=${handle}&limit=20&includePins=true`
				);
				if (!feedRes.ok) throw new Error('Feed fetch failed');
				const feedData = await feedRes.json();
				let posts = feedData.feed || [];
				console.log('📝 フィード取得:', posts.length, '件');
				
				console.log('フィード内のURI:', posts.map((p: any) => p.post?.uri));
 
				// ==========  固定ポストの処理 ==========
				// ★ 重要: viewer.pinned でも検出できるはず
				let pinnedPostItem: any = null;
 
				// viewer.pinned で検索
				const filteredPosts = posts.filter((item: any, idx: number) => {
					if (!item.post) return true; // postプロパティがない場合はスキップ

					// リプライ（返信）を除外する
					// item.reply が存在し、かつリポスト（item.reason）でない場合は表示しない
					if (item.reply && !item.reason) return false;

					// ★ pinnedUri が undefined でも、viewer.pinned で判定
					const isPinnedByUri = pinnedUri && item.post?.uri === pinnedUri;
					const isPinnedByViewer = item.post?.viewer?.pinned === true;
					// 理由コードによる判定（念のため2つのパターンをチェック）
					const isPinnedByReason = item.reason?.$type === 'app.bsky.feed.defs#skeletonReasonPin' || item.reason?.$type === 'app.bsky.feed.defs#reasonPin';
					
					console.log(`Post ${idx}:`, {
						uri: item.post.uri,
						viewer_pinned: item.post.viewer?.pinned,
						matches_uri: isPinnedByUri,
						reason_type: item.reason?.$type,
						is_pinned: isPinnedByUri || isPinnedByViewer || isPinnedByReason
					});
					
					if (isPinnedByUri || isPinnedByViewer || isPinnedByReason) {
						console.log('✅ 固定投稿を発見（フィード内）');
						pinnedPostItem = { ...item, isPinned: true };
						
						return false;
					}
					return true;
				});
 
				// 固定ポストが見つからければ個別取得
				if (!pinnedPostItem && pinnedUri) {
					try {
						console.log('🔍 個別取得を試行:', pinnedUri);
						const pinnedRes = await fetch(
							`https://public.api.bsky.app/xrpc/app.bsky.feed.getPosts?uris=${encodeURIComponent(pinnedUri)}`
						);
						if (pinnedRes.ok) {
							const pinnedData = await pinnedRes.json();
							console.log('個別取得の応答:', pinnedData);
							if (pinnedData.posts?.length > 0) {
								console.log('✅ 個別取得で固定投稿を発見');
								pinnedPostItem = {
									post: pinnedData.posts[0],
									isPinned: true
								};
							}
						}
					} catch (err) {
						console.warn('個別取得失敗:', err);
					}
				}
 
				if (!pinnedPostItem) {
					console.warn('⚠️ 固定投稿が見つかりません');
				}
 
				// 固定ポストを先頭に追加
				const finalPosts = pinnedPostItem
					? [pinnedPostItem, ...filteredPosts]
					: filteredPosts;
 
				console.log('📊 最終フィード:', {
					固定投稿: pinnedPostItem ? 'あり' : 'なし',
					通常投稿: filteredPosts.length,
					合計: finalPosts.length
				});
 
				// ========== 引用元の画像を事前に取得 ==========
				const enrichedPosts = await Promise.all(
					finalPosts.map(async (item: any) => {
						const enrichedItem = { ...item };
						
						if (item.post.embed?.record?.uri) {
							try {
								const quoteRes = await fetch(
									`https://public.api.bsky.app/xrpc/app.bsky.feed.getPosts?uris=${encodeURIComponent(item.post.embed.record.uri)}`
								);
								if (quoteRes.ok) {
									const quoteData = await quoteRes.json();
									if (quoteData.posts?.length > 0) {
										enrichedItem.quotedPost = quoteData.posts[0];
									}
								}
							} catch (err) {
								console.warn(`Failed to fetch quote:`, err);
							}
						}
						
						return enrichedItem;
					})
				);
 
				setFeed(enrichedPosts);
				setError(null);
			} catch (err) {
				console.error('Bluesky fetch error:', err);
				setError(`エラー: ${err instanceof Error ? err.message : '不明なエラー'}`);
				setFeed([]);
			} finally {
				setLoading(false);
			}
		};
 
		loadBlueskyFeed();
	}, []);



	const getImages = (post: any) => {
		return post.embed?.images || [];
		};

	const getQuoteImages = (quotedPost: any) => {
		if (!quotedPost) return [];
		return quotedPost.embed?.images || [];
	};

	// テキスト内のURLを検知してクリック可能な要素に変換する関数
	const renderTextWithLinks = (text: string) => {
		if (!text) return null;
		// URLを抽出する正規表現
		const urlRegex = /(https?:\/\/[^\s]+)/gi;
		const parts = text.split(urlRegex);

		return parts.map((part, i) => {
			if (part && /^https?:\/\//i.test(part)) {
				const url = part.trim();
				return (
					<a
						key={i}
						href={url}
						target="_blank"
						rel="noopener noreferrer"
						onClick={(e) => e.stopPropagation()} // 親要素のクリックを阻止
						style={{ color: '#0085FF', textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold', position: 'relative', zIndex: 2 }}
					>
						{part}
					</a>
				);
			}
			return part;
		});
	};





	//ここからページ内コンテンツ定義

	return (
		<div className="top-page">
			{/* 他ページと共通のグラデーション＋パーティクル背景 */}
			<div className="profile-page-wrapper"></div>

			<PageTitle />

			<div className="top-content">
				{/* スライドショー表示領域 */}
				{slideImages.length > 0 && (
					<div className="top-slideshow-container">
						{/* mode="wait" を消すことで、次の画像が表示されながら前の画像が消え、上書き（クロスフェード）されるようになります */}
						<AnimatePresence>
							{slideImages[currentIndex] && (() => {
								const illust = slideImages[currentIndex]!;
								// srcが配列なら1枚目を使用
								const displaySrc = Array.isArray(illust.src) ? illust.src[0] : (illust.src || (illust as any).images?.[0] || "");
								return (
							<motion.img
								key={currentIndex}
								src={displaySrc}
								alt={illust.title}
								className="top-slideshow-img"
								onClick={() => navigate(`/illust/${illust.id}`, { state: { backgroundLocation: { pathname: '/' } } })}
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
								transition={{ duration: 1.5, ease: "easeInOut" }}
							/>
							);})()}
						</AnimatePresence>
					</div>
				)}
				
				<br/>

				<motion.div 
					className="top-message-box"
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true, margin: "-10%" }}
					transition={{ duration: 1.0 }}
				>
					<p>ようこそ。Adzuki.のホームページへ。</p>
					<p>まだリニューアル工事中故に</p>
					<p>未完成な部分がかなり多いものではございますが、</p>
					<p>ゆっくりしていってください。</p><br/>
					<p>最終更新 2026/06/07</p>
				</motion.div>


				<div className="FlexArea">

					<div className="components">

						<div className="components-title"><p><MdAccessTime /> Update History</p></div>

							{/* 更新履歴リスト */}
							<div className="UpdateList">
								{[...UpdateList].reverse().map((item, index) => (
									<div key={index} style={{ marginBottom: '15px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '8px' }}>
										<span style={{ fontSize: '0.8rem', color: '#aaa', display: 'block' }}><FaStar /> {item.date}</span>
										<span style={{ fontSize: '0.95rem', color: '#eee', whiteSpace: 'pre-wrap' }}>{item.comment}</span>
									</div>
								))}
							</div>
						</div>



						<div className="components">
						<div className="components-title"><p><FaBookOpen /> Comic Ads</p></div>
						
							<div className="comics-ads">
								<p>躁のイマジア(1) 電子書籍版 販売開始！</p>

								<a rel="noreferrer sponsored" href="https://dlaf.jp/home/dlaf/=/t/i/link/work/aid/RP01073279/id/RJ01646577.html" target="_blank">
									<img itemProp="image" src="//img.dlsite.jp/modpub/images2/work/doujin/RJ01647000/RJ01646577_img_main.jpg" alt="" className="target_type" />
								</a>

								<p>↑アフィリエイトリンクです。↓</p>
								
								<div className="dlsite-link">
									<a rel="noreferrer sponsored" href="https://dlaf.jp/comic/dlaf/=/aid/RP01073279/url/https%3A%2F%2Fwww.dlsite.com%2Fcomic%2F%3Futm_medium%3Daffiliate%26utm_campaign%3Dbnlink%26utm_content%3Dtext" target="_blank">
										<img itemProp="image" src="https://www.dlsite.com/img/dlsitebn2.gif" alt="" className="target_type" />
									</a>
								</div>

							</div>


					</div>
				</div>


				<div className="FlexArea">


					<div className="components">
						
						<div className="components-title"><p><CiCalendar /> Schedule</p></div>
						{/* イベントリスト */}
						<div className="EventList">
							<EventLists />
						</div>
					</div>



					<div className="components">
						{/* BlueSkyタイムライン */}

						<div className="components-title"><a href="https://bsky.app/profile/adzuki0324.bsky.social" target="_blank" rel="noopener noreferrer"><SiBluesky /> Bluesky</a></div>
						
						<div className="BlueSky-timeline">
							{loading && <div className="loading-text">BlueSky NowLoding...</div>}
		
							{error && (
								<div className="loading-text" style={{ color: '#ff6b6b' }}>
									{error}
								</div>
							)}
		
							{!loading && feed.length === 0 && !error && (
								<div className="loading-text">投稿ナシ / Post NotFound</div>
							)}
		
							{feed.map((item) => {
								const { post, isPinned, quotedPost } = item;
								const isRepost = item.reason?.$type === 'app.bsky.feed.defs#reasonRepost';
								const date = new Date(post.indexedAt).toLocaleString('ja-JP', {
									year: 'numeric',
									month: '2-digit',
									day: '2-digit',
									hour: '2-digit',
									minute: '2-digit',
								});
								const images = getImages(post);
								const quoteImages = getQuoteImages(quotedPost);

								// BlueSkyの個別投稿ページへのURLを生成
								const rkey = post.uri.split('/').pop();
								const postUrl = `https://bsky.app/profile/${post.author.handle}/post/${rkey}`;
		
								return (
									<motion.div
										key={post.uri}
										className={`post-wrapper ${isPinned ? 'is-pinned' : ''} ${isRepost ? 'is-repost' : ''}`}
										whileHover={{ backgroundColor: "rgba(255, 255, 255, 0.05)", cursor: 'pointer' }}
										style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
										// ポスト全体をクリックした時の処理。
										onClick={(e) => {
											const target = e.target as HTMLElement;
											if (target.closest('a')) return;
											window.open(postUrl, '_blank', 'noopener,noreferrer');
										}}
									>
										{isPinned && (
											<div className="pinned-label">📌 固定</div>
										)}
										{isRepost && (
											<div className="repost-label">🔄 RP</div>
										)}
		
										<div className="bsky-post-header">
											<img
												src={post.author.avatar}
												alt=""
												className="bsky-avatar"
											/>
											<div className="bsky-user-meta">
												<span className="bsky-name">
													{post.author.displayName}
												</span>
												<span className="bsky-date">{date}</span>
											</div>
										</div>
		
										<div className="bsky-text" style={{ whiteSpace: 'pre-wrap' }}>
											{renderTextWithLinks((post.record as any).text)}
										</div>
		
										{/* 自分の投稿画像 */}
										{images.length > 0 && (
											<div
												className="bsky-image-grid"
												style={{
													display: 'grid',
													gap: '8px',
													marginTop: '10px',
													gridTemplateColumns: images.length === 1 ? '1fr' : 'repeat(2, 1fr)',
													gridTemplateRows: images.length === 3 ? 'repeat(2, 1fr)' : 'none',
													aspectRatio: images.length >= 2 ? '16/10' : 'auto',
												}}
											>
												{images.map((img: any, i: number) => (
													<img
														key={i}
														src={img.thumb}
														alt=""
														className="bsky-content-img"
														style={images.length === 1
															? { width: '100%', height: 'auto', objectFit: 'contain', borderRadius: '8px', maxHeight: '500px' }
															: images.length === 3
																? { width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', gridColumn: i === 2 ? '2' : '1', gridRow: i === 2 ? '1 / span 2' : 'auto' }
																: { width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }
														}
													/>
												))}
											</div>
										)}
		
										{/* 引用先の投稿 */}
										{quotedPost && (
											<div
												style={{
													marginTop: '12px',
													padding: '12px',
													border: '1px solid rgba(255,255,255,0.1)',
													borderRadius: '8px',
													background: 'rgba(255,255,255,0.05)',
													fontSize: '0.85rem'
												}}
											>
												<div style={{ marginBottom: '8px' }}>
													<span
														style={{
															fontWeight: 'bold',
															color: '#fff'
														}}
													>
														{quotedPost.author?.displayName}
													</span>
													<span style={{ color: '#888', marginLeft: '8px' }}>
														{new Date(quotedPost.indexedAt).toLocaleString('ja-JP', {
															year: 'numeric',
															month: '2-digit',
															day: '2-digit',
															hour: '2-digit',
															minute: '2-digit',
														})}
													</span>
												</div>
		
												<div
													style={{
														color: '#ddd',
														marginBottom: '8px',
														whiteSpace: 'pre-wrap'
													}}
												>
													{renderTextWithLinks((quotedPost.record as any).text)}
												</div>
		
												{/* 引用先の画像 */}
												{quoteImages.length > 0 && (
													<div
														className="bsky-image-grid"
														style={{
															display: 'grid',
															gap: '8px',
															marginTop: '10px',
															gridTemplateColumns: quoteImages.length === 1 ? '1fr' : 'repeat(2, 1fr)',
															gridTemplateRows: quoteImages.length === 3 ? 'repeat(2, 1fr)' : 'none',
															aspectRatio: quoteImages.length >= 2 ? '16/10' : 'auto',
														}}
													>
														{quoteImages.map((img: any, i: number) => (
															<img
																key={i}
																src={img.thumb}
																alt=""
																className="bsky-content-img"
																style={quoteImages.length === 1
																	? { width: '100%', height: 'auto', objectFit: 'contain', borderRadius: '4px', maxHeight: '400px' }
																	: quoteImages.length === 3
																		? { width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px', gridColumn: i === 2 ? '2' : '1', gridRow: i === 2 ? '1 / span 2' : 'auto' }
																		: { width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }
																}
															/>
														))}
													</div>
												)}
											</div>
										)}
									</motion.div>
								);
							})}

						</div>					
					</div>

					

				</div>

			</div>
		</div>

	);



};

export default Top;